import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-pricing',
  imports: [MatCardModule, MatButtonModule, MatIconModule, RouterModule, TranslateModule],
  templateUrl: './pricing.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './pricing.component.css'
})
export class PricingComponent {
  pods = [
    {
      name: 'nano',
      price: '2.50',
      vcpu: '0.25',
      ram: '256 MB',
      storage: '1 GB',
      highlighted: false,
      creditCovered: true
    },
    {
      name: 'small',
      price: '5',
      vcpu: '0.5',
      ram: '512 MB',
      storage: '2 GB',
      highlighted: true,
      creditCovered: false
    },
    {
      name: 'medium',
      price: '10',
      vcpu: '1',
      ram: '1 GB',
      storage: '4 GB',
      highlighted: false,
      creditCovered: false
    },
    {
      name: 'large',
      price: '15',
      vcpu: '1',
      ram: '2 GB',
      storage: '4 GB',
      highlighted: false,
      creditCovered: false
    },
    {
      name: 'big',
      price: '30',
      vcpu: '2',
      ram: '4 GB',
      storage: '4 GB',
      highlighted: false,
      creditCovered: false
    }
  ];
}
